import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=7c4b8280&scoped=true&"
import script from "./Feedback.vue?vue&type=script&lang=js&"
export * from "./Feedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4b8280",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c4b8280')) {
      api.createRecord('7c4b8280', component.options)
    } else {
      api.reload('7c4b8280', component.options)
    }
    module.hot.accept("./Feedback.vue?vue&type=template&id=7c4b8280&scoped=true&", function () {
      api.rerender('7c4b8280', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Support/TicketSingle/Feedback.vue"
export default component.exports